import React from 'react';
import {FaCopyright} from "react-icons/fa";

export default function footer(){
    return(
        <div className="footer">
            <p className="footer-text"><FaCopyright className="icon"/> Alex Vazquez, 2020.</p>
        </div>
    );
}